import React from 'react';
import { makeStyles, createStyles, Theme, Divider, FormControlLabel, Checkbox } from '@material-ui/core';
import Utils from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { getOperator } from '../../screens/admin/action';
import { ReducersModel } from '../../model';
import IndeterminateCheckBoxOutlinedIcon from '@material-ui/icons/IndeterminateCheckBoxOutlined';
import { useTranslation } from 'react-i18next';

const styles = makeStyles((theme: Theme) =>
    createStyles({
        mainContainer: {
            minWidth: '210px',
        },
        title: {
            padding: '0 16px 8px 16px',
            textAlign: 'left',
            font: 'normal normal normal 14px/21px Roboto',
            letterSpacing: '0.08px',
            color: '#515151',
            opacity: 1,
        },
        subTitle: {
            padding: '8px 16px',
            textAlign: 'left',
            font: 'normal normal normal 14px/21px Roboto',
            letterSpacing: '0.08px',
            color: '#515151',
            opacity: 1,
        },
        filtersBox: {
            padding: '8px 16px',
            textAlign: 'left',
            font: 'normal normal normal 14px/21px Roboto',
            letterSpacing: '0.08px',
            color: '#515151',
            opacity: 1,
            display: 'flex',
            flexDirection: 'column',
            '& .MuiTypography-root': {
                textAlign: 'left',
                font: 'normal normal normal 12px/21px Roboto',
                letterSpacing: '0.07px',
                color: '#868686',
                opacity: 1,
            },
            '& .MuiCheckbox-root': {
                padding: '2px 7px',
            },
            '& .MuiFormGroup-root': { flexDirection: 'row!important' },
        },
        statusContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        status: {
            marginRight: '40px',
            textAlign: 'left',
            font: 'normal normal normal 14px/21px Roboto',
            letterSpacing: '0.08px',
            color: '#515151',
            opacity: 1,
        },
        indeterminateColor: {
            color: '#1E88E5',
        },
        disabledCheck: {
            '& .MuiTypography-body1': {
                fontStyle: 'italic',
                color: '#868686',
            },
        },
        naturalCheck: {
            '& .MuiTypography-root': {
                color: '#515151',
            },
        },
    }),
);

export default function ManageOperatorFilter({ mfgLines, shifts }: any) {
    const classes = styles();
    const { filterStatus, filterLineIds, filterShiftIds } = useSelector(
        (state: ReducersModel) => state.operatorReducer,
    );
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <div className={classes.mainContainer}>
            <div className={classes.title}>{t('Filterby')}</div>
            <Divider />
            <div>
                <div className={classes.subTitle}>{t('Status')}</div>
                <div className={classes.filtersBox}>
                    <FormControlLabel
                        value={'true'}
                        className={classes.naturalCheck}
                        control={
                            <Checkbox
                                color={'primary'}
                                name="shift"
                                checked={filterStatus.includes('true')}
                                onChange={(event: any) => {
                                    const target = event.target;
                                    if (target.checked) {
                                        if (!filterStatus.includes(target.value)) {
                                            let newArray = [...filterStatus];

                                            newArray.push(target.value);
                                            dispatch({
                                                type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                payload: {
                                                    filterStatus: newArray,
                                                },
                                            });
                                            dispatch(getOperator());
                                        }
                                    } else {
                                        if (filterStatus.includes(target.value)) {
                                            const index = filterStatus.indexOf(target.value);
                                            let newArray = [...filterStatus];
                                            if (index > -1) {
                                                newArray.splice(index, 1);
                                            }
                                            dispatch({
                                                type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                payload: {
                                                    filterStatus: newArray,
                                                },
                                            });
                                            dispatch(getOperator());
                                        }
                                    }
                                }}
                            />
                        }
                        label={t('Active')}
                    />
                    <FormControlLabel
                        value={'false'}
                        className={classes.naturalCheck}
                        control={
                            <Checkbox
                                color={'primary'}
                                name="shift"
                                checked={filterStatus.includes('false')}
                                onChange={(event: any) => {
                                    const target = event.target;
                                    if (target.checked) {
                                        if (!filterStatus.includes(target.value)) {
                                            let newArray = [...filterStatus];

                                            newArray.push(target.value);
                                            dispatch({
                                                type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                payload: {
                                                    filterStatus: newArray,
                                                },
                                            });
                                            dispatch(getOperator());
                                        }
                                    } else {
                                        if (filterStatus.includes(target.value)) {
                                            const index = filterStatus.indexOf(target.value);
                                            let newArray = [...filterStatus];
                                            if (index > -1) {
                                                newArray.splice(index, 1);
                                            }
                                            dispatch({
                                                type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                payload: {
                                                    filterStatus: newArray,
                                                },
                                            });
                                            dispatch(getOperator());
                                        }
                                    }
                                }}
                            />
                        }
                        label={t('Inactive')}
                    />
                </div>
                <Divider />
            </div>
            {shifts && shifts.length > 0 &&
                <div>
                    <div className={classes.subTitle}>{t('Shift')}</div>
                    <div className={classes.filtersBox}>
                        <div>
                            {shifts && shifts.length > 2 && (
                                <FormControlLabel
                                    className={classes.naturalCheck}
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            checked={shifts?.length === filterShiftIds.length}
                                            indeterminate={
                                                filterShiftIds.length !== 0 && shifts?.length !== filterShiftIds.length
                                            }
                                            indeterminateIcon={
                                                <IndeterminateCheckBoxOutlinedIcon className={classes.indeterminateColor} />
                                            }
                                            inputProps={{
                                                'aria-label': 'decorative checkbox',
                                            }}
                                            onChange={(event: any) => {
                                                const target = event.target;
                                                if (target.checked) {
                                                    let newArray = shifts.map((a: any) => `${a.id}`);
                                                    dispatch({
                                                        type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                        payload: {
                                                            filterShiftIds: newArray,
                                                        },
                                                    });
                                                    dispatch(getOperator());
                                                } else {
                                                    dispatch({
                                                        type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                        payload: {
                                                            filterShiftIds: [],
                                                        },
                                                    });
                                                    dispatch(getOperator());
                                                }
                                            }}
                                        />
                                    }
                                    label={<div>{t('All')}</div>}
                                />
                            )}
                        </div>
                        {shifts && shifts.length > 0 ? (
                            shifts.map((shift: any, index: number) => {
                                return (
                                    <FormControlLabel
                                        key={index}
                                        value={shift.id}
                                        className={shift.isActive ? classes.naturalCheck : classes.disabledCheck}
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                name="shift"
                                                checked={filterShiftIds.includes(`${shift.id}`)}
                                                onChange={(event: any) => {
                                                    const target = event.target;
                                                    if (target.checked) {
                                                        if (!filterShiftIds.includes(target.value)) {
                                                            let newArray = [...filterShiftIds];

                                                            newArray.push(target.value);
                                                            dispatch({
                                                                type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                                payload: {
                                                                    filterShiftIds: newArray,
                                                                },
                                                            });
                                                            dispatch(getOperator());
                                                        }
                                                    } else {
                                                        if (filterShiftIds.includes(target.value)) {
                                                            const index = filterShiftIds.indexOf(target.value);
                                                            let newArray = [...filterShiftIds];
                                                            if (index > -1) {
                                                                newArray.splice(index, 1);
                                                            }
                                                            dispatch({
                                                                type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                                payload: {
                                                                    filterShiftIds: newArray,
                                                                },
                                                            });
                                                            dispatch(getOperator());
                                                        }
                                                    }
                                                }}
                                            />
                                        }
                                        label={shift.shift}
                                    />
                                );
                            })
                        ) : (
                            <div>{t('NoRecordfound')}</div>
                        )}
                    </div>
                    <Divider />
                </div>
            }

            <div>
                <div className={classes.subTitle}>{t('Line')}</div>
                <div className={classes.filtersBox}>
                    <div>
                        {mfgLines && mfgLines.length > 2 && (
                            <FormControlLabel
                                className={classes.naturalCheck}
                                control={
                                    <Checkbox
                                        color={'primary'}
                                        checked={mfgLines?.length === filterLineIds.length}
                                        indeterminate={
                                            filterLineIds.length !== 0 && mfgLines?.length !== filterLineIds.length
                                        }
                                        indeterminateIcon={
                                            <IndeterminateCheckBoxOutlinedIcon className={classes.indeterminateColor} />
                                        }
                                        inputProps={{
                                            'aria-label': 'decorative checkbox',
                                        }}
                                        onChange={(event: any) => {
                                            const target = event.target;
                                            if (target.checked) {
                                                let newArray = mfgLines.map((a: any) => `${a.id}`);
                                                dispatch({
                                                    type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                    payload: {
                                                        filterLineIds: newArray,
                                                    },
                                                });
                                                dispatch(getOperator());
                                            } else {
                                                dispatch({
                                                    type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                    payload: {
                                                        filterLineIds: [],
                                                    },
                                                });
                                                dispatch(getOperator());
                                            }
                                        }}
                                    />
                                }
                                label={<div>{t('All')}</div>}
                            />
                        )}
                    </div>
                    {mfgLines && mfgLines.length > 0 ? (
                        mfgLines.map((mfgLine: any, index: number) => {
                            return (
                                <FormControlLabel
                                    key={index}
                                    value={mfgLine.id}
                                    className={mfgLine.isActive ? classes.naturalCheck : classes.disabledCheck}
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            checked={filterLineIds.includes(`${mfgLine.id}`)}
                                            onChange={(event: any) => {
                                                const target = event.target;
                                                if (target.checked) {
                                                    if (!filterLineIds.includes(target.value)) {
                                                        let newArray = [...filterLineIds];

                                                        newArray.push(target.value);
                                                        dispatch({
                                                            type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                            payload: {
                                                                filterLineIds: newArray,
                                                            },
                                                        });
                                                        dispatch(getOperator());
                                                    }
                                                } else {
                                                    if (filterLineIds.includes(target.value)) {
                                                        const index = filterLineIds.indexOf(target.value);
                                                        let newArray = [...filterLineIds];
                                                        if (index > -1) {
                                                            newArray.splice(index, 1);
                                                        }
                                                        dispatch({
                                                            type: Utils.ActionName.UPDATE_OPERATOR_LIST,
                                                            payload: {
                                                                filterLineIds: newArray,
                                                            },
                                                        });
                                                        dispatch(getOperator());
                                                    }
                                                }
                                            }}
                                            name="line"
                                        />
                                    }
                                    label={mfgLine.mfgLine}
                                />
                            );
                        })
                    ) : (
                        <div>{t('NoRecordfound')}</div>
                    )}
                </div>
            </div>
        </div>
    );
}
